import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
import IngestProcessFields from './formGroup21ProcessesFields';
import tableIngestServerRelationship from '../../tableIngestServerRelationship';


export default {
  title: 'General configuration',
  attributeName: 'ingestServer',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'nextId',
      label: 'NEXTID',
      helpText: 'Type of the ingest server.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'type',
      label: 'Type',
      helpText: 'The type of camera input ingested by this process.',
      type: FormInputTypes.SELECT,
      default:'180',
      flushChildrenOnchange:'name',
      disabledWhenEdit:true,
      options: [
        { name: 'flat', value: 'flat' },
        { name: '180', value: '180' },
        { name: '360', value: '360', disabled:true },
        { name: 'Control room', value: 'controlroom'},
        { name: 'Cloud control room (CCR)', value: 'ccr' },
      ],
      visibleWhen:[{"field":"deploymentType","value":"ott"},{"field":"deploymentGPU","value":true}],

    },
    {
      attributeName: 'type',
      label: 'Type',
      helpText: 'The type of camera input ingested by this process.',
      type: FormInputTypes.SELECT,
      default:'180',
      flushChildrenOnchange:'name',
      disabledWhenEdit:true,
      options: [
        { name: 'flat', value: 'flat' },
        { name: '180', value: '180' },
        { name: '360', value: '360' },
        { name: 'Control room', value: 'controlroom' },
        { name: 'Cloud control room (CCR)', value: 'ccr', disabled:true},
      ],
      visibleWhen:[{"field":"deploymentType","value":"ott"},{"field":"deploymentGPU","value":"bool-false"}],
    },
    {
      attributeName: 'type',
      label: 'Type',
      helpText: 'The type of camera input ingested by this process.',
      type: FormInputTypes.SELECT,
      default:'180',
      flushChildrenOnchange:'name',
      disabledWhenEdit:true,
      options: [
        { name: 'flat', value: 'flat' },
        { name: '180', value: '180' },
        { name: '360', value: '360'},
        { name: 'Control room', value: 'controlroom'},
        // { name: 'Cloud control room (CCR)', value: 'ccr' },
      ],
      visibleWhen:[{"field":"deploymentType","value":"lowLatency"}],

    }, 
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Agent name',
      label: 'Agent Name',
      required: true,
      valueWhen:[{"field":"type","value":["Agent_","concat","left"]},{"from":"parentData","field":"type","mode":"cont","value":["_","concat","right",">1"]}],
      helpText: 'Set the Agent name for the ingestion.',
      disabled:false,
      errorText: '',
    },
    {
      attributeName: 'ip',
      type: FormInputTypes.TEXT_INPUT.OBJECT,
      helpText: 'URL of the video dash manifest. You can search for a processed video by the VoD backend in the next button.',
      label: 'Ingest server IP',
      placeholder: 'Video Url...',
      mainField:"ip",
      returnValue:"ip",
      inputEnabled:true,
      fromConfigTable: tableIngestServerRelationship,
    },
    {
      attributeName: 'recordingDirectory',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the folder',
      label: 'Recording directory',
      default:'/media/ybvr/recordings',
      required: true,
      helpText: 'Set the Ip .',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":"ott"},

    },
    {
      attributeName: 'highlightsDirectory',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the folder',
      label: 'Highlights directory',
      default:'/media/ybvr/highlights',
      required: true,
      helpText: 'Set the Ip .',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":"ott"},
    },
    {
      attributeName: 'inFPS',
      type: FormInputTypes.SELECT,
      label: 'In FPS',
      default:'60',
      options: [
        { name: '30', value: 30 },
        { name: '60', value: 60 },
      ],
      helpText: 'Set inFPS of 30 or 60.',
      errorText: '',
    },
    {
      attributeName: 'outFPS',
      type: FormInputTypes.SELECT,
      label: 'Out FPS',
      default:'60',
      options: [
        { name: '30', value: 30 },
        { name: '60', value: 60 },
      ],
      helpText: 'Set outFPS of 30 or 60.',
      errorText: '',
    },
    // {
    //   attributeName: 'videoCodec',
    //   type: FormInputTypes.SELECT,
    //   label: 'Video codec',
    //   default:'hevc_nvenc',
    //   options: [
    //     { name: 'hevc_nvenc', value: 'hevc_nvenc' },
    //     { name: 'h264_nvenc', value: 'h264_nvenc' },
    //   ],
    //   helpText: 'Video codec .',
    //   errorText: '',
    //   visibleWhen:[{"field":"deploymentType","value":"lowLatency"}],

    // },
    {
      attributeName: 'audioBitrate',
      label: 'Audio bitrate',
      helpText: 'Audio bitrate .',
      default: '256',
      type: FormInputTypes.SELECT,
      options: [
        { name: '256', value: 256 },
        { name: '128', value: 128 },
        { name: '64', value: 64 },
        { name: '32', value: 32 },
      ],
    },
    { 
      attributeName: 'decklinkFormat', // # Only needed for Decklink sources
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the decklinkFormat',
      label: 'Decklink format',
      default:'Hi50',
      visibleWhen:{"field":"type","value":"controlroom"},
      required: true,
      helpText: 'Enter the decklink format, only needed for Decklink sources.',
      errorText: '',
    },
    { 
      attributeName: 'decklinkPixelFormat', // # Only needed for Decklink sources
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the decklink pixel format',
      label: 'Decklink pixel format',
      default:'uyvy422',
      visibleWhen:{"field":"type","value":"controlroom"},
      required: true,
      helpText: 'Enter the decklink pixel format, only needed for Decklink sources.',
      errorText: '',
    },
    { 
      attributeName: 'decklinkFormat', // # Only needed for Decklink sources
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the decklinkFormat',
      label: 'Decklink format',
      default:'Hi50',
      visibleWhen:{"field":"type","value":"ccr"},
      required: true,
      helpText: 'Enter the decklink format, only needed for Decklink sources.',
      errorText: '',
    },
    
    { 
      attributeName: 'decklinkPixelFormat', // # Only needed for Decklink sources
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'enter the decklink pixel format',
      label: 'Decklink pixel format',
      default:'uyvy422',
      visibleWhen:{"field":"type","value":"ccr"},
      required: true,
      helpText: 'Enter the decklink pixel format, only needed for Decklink sources.',
      errorText: '',
    },
    {
      attributeName: 'ingestProcesses',
      type: FormInputTypes.JSON_COMPONENT,
      classCss:'jsonComponent__width100',
      emptyMessage: "You don't have any ingest process yet.",
      columns:1,
      label: 'Ingest Processes',
      itemLabel:'Ingest process',
      required: true,
      extraValues:['deploymentType','type'],
      helpText: 'Insert new ingest Processes clicking in + button.',
      errorText: '',
      popupFormGroups:[
        IngestProcessFields
      ]
    },
  ]
};
